module.exports = __webpack_public_path__ + "img/avatar-clear.a944c47c.png";